module.exports = __webpack_public_path__ + "img/ta-hj-leftTitle03.297a879c.png";